import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuth } from './store';

const PLATFORM_URL =
  (import.meta.env['VITE_PLATFORM_URL'] as string | undefined) ||
  'http://localhost:7001';

export function OAuthCallback(): JSX.Element {
  const navigate = useNavigate();
  const login = useAuth((s) => s.login);
  const status = useAuth((s) => s.status);
  const [error, setError] = useState<string | null>(null);
  const exchanged = useRef(false);

  useEffect(() => {
    if (status === 'authenticated') {
      navigate('/embark', { replace: true });
      return;
    }

    if (exchanged.current) return;
    exchanged.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const state = params.get('state');

    if (!code || !state) {
      setError('Missing authorization parameters.');
      return;
    }

    (async () => {
      try {
        const res = await fetch(
          `${PLATFORM_URL}/auth/discord/callback?code=${encodeURIComponent(code)}&state=${encodeURIComponent(state)}`,
        );

        if (!res.ok) {
          const text = await res.text();
          setError(text || `Authentication failed (${res.status})`);
          return;
        }

        const data = (await res.json()) as {
          access_token: string;
          refresh_token: string;
        };
        login(data.access_token, data.refresh_token);
        navigate('/embark', { replace: true });
      } catch (e) {
        setError(e instanceof Error ? e.message : 'Authentication failed');
      }
    })();
  }, [login, navigate, status]);

  if (error) {
    return (
      <div style={containerStyle}>
        <div style={cardStyle}>
          <div style={{ color: '#ed4245', fontSize: 16, marginBottom: 12 }}>
            Sign-in failed
          </div>
          <div style={{ color: '#949ba4', fontSize: 14, marginBottom: 20 }}>
            {error}
          </div>
          <button style={btnStyle} onClick={() => navigate('/login', { replace: true })}>
            Back to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <div style={{ color: '#dcddde', fontSize: 16 }}>Signing in...</div>
      </div>
    </div>
  );
}

const containerStyle: React.CSSProperties = {
  height: '100vh',
  background: '#1e1f22',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontFamily:
    "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', sans-serif",
};

const cardStyle: React.CSSProperties = {
  background: '#2b2d31',
  border: '1px solid #3f4147',
  borderRadius: 8,
  padding: '32px 40px',
  textAlign: 'center',
};

const btnStyle: React.CSSProperties = {
  background: '#5865f2',
  color: '#ffffff',
  border: 'none',
  borderRadius: 4,
  padding: '10px 20px',
  fontSize: 14,
  fontWeight: 600,
  cursor: 'pointer',
};
